import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function register(state = initialState.news, action) {
    switch (action.type) {
        case types.LOAD_NEWS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            })
        case types.LOAD_NEWS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: '',
                data: action.data
            })
        case types.LOAD_NEWS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: {
                    ...action.messages
                }
            })
        case types.LOAD_MORE_NEWS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            })
        case types.LOAD_MORE_NEWS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: '',
                data: {...action.data, results: [...state.data.results, ...action.data.results]}
            })
        case types.LOAD_MORE_NEWS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: {
                    ...action.messages
                }
            })
        case types.LOAD_ITEM_NEWS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            })
        case types.LOAD_ITEM_NEWS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: '',
                data: action.data
            })
        case types.LOAD_ITEM_NEWS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: {
                    ...action.messages
                }
            })
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/newsReducer.js